import React from "react";
import { Badge, Col, Container, Row } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/free-regular-svg-icons";

interface Props {
  questions: string[];
}

function translateQuestionToEs(question: string): string {
  const normalized = String(question || "").trim().toLowerCase();
  const dict: Record<string, string> = {
    "full name": "Nombre completo",
    "first name": "Nombre",
    "last name": "Apellido",
    email: "Correo electrónico",
    "phone number": "Número de teléfono",
    phone: "Teléfono",
    mobile: "Celular",
    city: "Ciudad",
    country: "País",
    company: "Empresa",
    "company name": "Nombre de la empresa",
    "job title": "Cargo",
    website: "Sitio web",
    message: "Mensaje",
  };
  return dict[normalized] || question;
}

export default function FormQuestions(props: Props) {
  const { questions } = props;

  return (
    <Container className="h-100 p-4 facebook-form-questions" fluid>
      <Row className="h-100">
        <Col xs="12">
          <div className="d-flex flex-column h-100">
            <h2 className="facebook-form-questions__title mb-2">Preguntas del formulario</h2>
            <p className="facebook-form-questions__lead mb-4">
              Estas son las preguntas que Facebook mostraba al usuario cuando completó este formulario.
              Te ayudan a entender el contexto de cada lead y ordenar mejor el seguimiento.
            </p>

            {questions && questions.length > 0 ? (
              <div className="facebook-form-questions__list">
                {questions.map((question, index) => (
                  <div key={`${question}-${index}`} className="facebook-form-questions__item">
                    <Badge pill className="facebook-form-questions__index">
                      {index + 1}
                    </Badge>
                    <span className="facebook-form-questions__text">
                      {translateQuestionToEs(question)}
                    </span>
                  </div>
                ))}
              </div>
            ) : (
              <div className="facebook-form-questions__empty">
                <FontAwesomeIcon icon={faCircleQuestion} className="mr-2" />
                No hay preguntas disponibles para este formulario.
              </div>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
}
